// #650, Session 79.22b -- WHEN NOBODY AT A BRANCH CAN DECIDE, THE PEOPLE WHO
// CAN DECIDE ANYWHERE ARE ASKED.
//
// A bell that ASKS for a decision -- approve this request, confirm you can
// supply it, choose what happens after a refusal -- goes to the managers who may
// make it. A branch with none of them (a vacancy, a yard with no office, Austin
// today) came back as an empty list, and sendNotification([]) is a silent
// success: the request waited on nobody and nothing anywhere said it existed.
// Every admin and executive may approve at any branch (canApprove() and
// canApproveTransfer() both let them through), so they are who is asked instead.
//
// THIS WRAPS THE LIST A CALLER HAS ALREADY BUILT; it is not a change to
// getRequestApproverIds(). That lookup also backs the approval EMAILS and every
// informational bell ("on its way", "received"), where an empty list means
// nobody is owed the message -- so only the call sites that ask somebody to
// DECIDE use this. Where a branch has anybody who can decide -- Dallas, Houston
// and San Antonio today -- it returns exactly the list it was given.
//
// Logged when it fires, the way notify.js logs a failed insert: the emptiness is
// the thing #650 found nobody could see.
import { getAdminExecutiveIds } from './notify';

export async function orEveryoneWhoCanDecide(ids, branchId = null) {
  const list = [...new Set((ids || []).filter(Boolean))];
  if (list.length) return { ids: list, fallback: false };
  const everywhere = [...new Set(((await getAdminExecutiveIds()) || []).filter(Boolean))];
  console.warn('[#650] nobody at branch', branchId, 'can decide this - asked every admin and executive instead:', everywhere.length);
  return { ids: everywhere, fallback: true };
}
